export default __webpack_public_path__ + "static/media/능력발휘.998e330c.png";